import Backend from 'App/Dataman-Backend';
import { apiGet, apiPost, apiPatch, apiDelete } from '@/app/api/core/http';
import { PRODUCTS_PATHS } from './paths';

export const marketCountriesApiAdapter = {
  productMarketCountries: {
    getList: (params) => apiGet(PRODUCTS_PATHS.marketCountries + PRODUCTS_PATHS.suffix, { params }),
    createItem: (data) => apiPost(PRODUCTS_PATHS.marketCountries, { data }),
    updateItem: (id, data) => apiPatch(`${PRODUCTS_PATHS.marketCountries}/${id}`, { data }),
    deleteItem: (id) => apiDelete(`${PRODUCTS_PATHS.marketCountries}/${id}`),
  },
  getProductMarketCountries: (params) => apiGet(PRODUCTS_PATHS.countriesProductMarkets, { params }),
  uploadMarketCountryEvidence: (data) => apiPost(PRODUCTS_PATHS.evidenceUpload, { data }),
  downloadEvidences: async (id) => {
    const res = await Backend.loadBlobData({
      url: `${PRODUCTS_PATHS.marketCountriesFiles}/${id}`,
      method: 'get',
      responseType: 'blob',
      headers: { accept: 'application/octet-stream' },
    });
    return res;
  },
};
